import { serializeCsv } from "./csvParse";

/** Commercial import template — columns align with projectCsvImportFields aliases. */
export const PROJECT_IMPORT_CSV_TEMPLATE_HEADERS = [
  "work_order",
  "customer",
  "new_customer",
  "project",
  "type",
  "subtype",
  "status",
  "phase",
  "subphase",
  "foc_date",
  "sales_rep",
  "departments",
  "site_walk",
  "service_location",
  "a_location",
  "z_location",
  "drafter",
  "inspector",
  "splicer",
  "assigned_technician",
  "service_speed",
  "circuit_id",
  "connection",
  "handoff",
  "ips",
  "it_contact",
  "it_number",
  "it_email",
  "mrc",
  "nrc",
  "term",
  "invoiced",
  "accounting_contact",
  "accounting_number",
  "accounting_email",
];

const SAMPLE_ROWS = [
  {
    work_order: "13211",
    customer: "Example Bank",
    new_customer: "true",
    project: "Safti First National Bank",
    type: "Revenue",
    subtype: "New",
    status: "Active",
    phase: "Drafting",
    subphase: "In Progress",
    foc_date: "",
    sales_rep: "Jane Smith",
    departments: "Engineering,Networking,Accounting",
    site_walk: "false",
    service_location: "100 Commerce Dr, Austin TX",
    a_location: "",
    z_location: "",
    drafter: "",
    inspector: "",
    splicer: "",
    assigned_technician: "",
    service_speed: "1g",
    circuit_id: "CVIN-13211-00",
    connection: "DIA",
    handoff: "Fiber",
    ips: "29",
    it_contact: "",
    it_number: "",
    it_email: "",
    mrc: "1250.00",
    nrc: "500",
    term: "36",
    invoiced: "",
    accounting_contact: "",
    accounting_number: "",
    accounting_email: "",
  },
];

export function buildProjectImportCsvTemplate() {
  return serializeCsv(PROJECT_IMPORT_CSV_TEMPLATE_HEADERS, SAMPLE_ROWS);
}

export function downloadProjectImportCsvTemplate(filename = "commercial-import-template.csv") {
  const csv = buildProjectImportCsvTemplate();
  const blob = new Blob(["\uFEFF", csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = "noopener";
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
